import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-premium-analytics',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {}
